import './card-days.scss';

export default () => {

};
